import {
  AssessmentDto,
  DiagnosticCompletionDto,
  DiagnosticCompletionSpec,
  DiagnosticResponseDto,
} from "@coaching-culture/types";
import axios from "axios";
import { useQuery } from "react-query";

export const getDiagnosticReponses = () =>
  axios
    .get<DiagnosticResponseDto[]>(`/api/v2/diagnostic-responses`)
    .then(({ data }) => data);

export const getDiagnostic = () =>
  axios.get<AssessmentDto>(`/api/v2/diagnostic`).then(({ data }) => data);

export const submitDiagnostic = (spec: DiagnosticCompletionSpec) =>
  axios
    .post<DiagnosticCompletionDto>(`/api/v2/diagnostic/submit`, spec)
    .then(({ data }) => data);

export const useDiagnostic = () => useQuery(["diagnostic"], getDiagnostic);

export const useDiagnosticResponses = () =>
  useQuery(["diagnostic-responses"], getDiagnosticReponses);
